import { globalStyObj } from '@/assets/packageAssets/allStyleConfigs/a-global-cfg.js'

import { echoStyObj } from '@/assets/packageAssets/allStyleConfigs/echo.cfg.js'
import { joychatStyObj } from '@/assets/packageAssets/allStyleConfigs/joychat.cfg.js'
import { kikoStyObj } from '@/assets/packageAssets/allStyleConfigs/kiko.cfg.js'
import { vavaStyObj } from '@/assets/packageAssets/allStyleConfigs/vava.cfg.js'
import { vibeoStyObj } from '@/assets/packageAssets/allStyleConfigs/vibeo.cfg.js'

// 包变量
const styObj = {
  default: {
    // 样式资源
    ...vibeoStyObj,
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv1.png')})`
  },
  echo: {
    // 样式资源
    ...echoStyObj,
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv1.png')})`,
    '--icon-level2': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv0.png')})`
  },
  joychat: {
    // 样式资源
    ...joychatStyObj,
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv1.png')})`
  },
  kiko: {
    // 样式资源
    ...kikoStyObj,
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv1.png')})`
  },
  vava: {
    // 样式资源
    ...vavaStyObj,
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv1.png')})`
  },
  vibeo: {
    // 样式资源
    ...vibeoStyObj,
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv1.png')})`
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return { ...globalStyObj, ...styObj[this.packageName] }
        }
        // 未配置
        else {
          return { ...globalStyObj, ...styObj['default'] }
        }
      }
      return {}
    }
  }
}
